module.exports = __webpack_public_path__ + "img/product_22.a1895ae.webp";